/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDVIDEOTAG,ADDVIDEOTAG_RECEIVED } = constants.AddVideoTagConstant;

export default {
    REQUEST_ADDVIDEOTAG,
    ADDVIDEOTAG_RECEIVED,

  requestAddVideoTag: payload => ({
    type: REQUEST_ADDVIDEOTAG,
    payload
  }),
  AddVideoTagReceived: () => ({
    type: ADDVIDEOTAG_RECEIVED
  }),
};
